// DesktopNav.js
import { Link } from 'react-router-dom';

const DesktopNav = ({ user }) => (
  <nav className={`hidden md:flex absolute left-1/2 transform ${
    user ? '-translate-x-1/2' : '-translate-x-[60%]'
  }`}>
    <ul className="flex items-center gap-4 lg:gap-6 xl:gap-8 font-bold uppercase text-sm lg:text-base xl:text-lg">
      <li>
        <Link to="/" className="hover:bg-gray-100 px-3 py-2 rounded-[2px] transition-colors">
          Strona główna
        </Link>
      </li>
      <li>
        <Link to="/listings" className="hover:bg-gray-100 px-3 py-2 rounded-[2px] transition-colors">
          Lista ogłoszeń
        </Link>
      </li>
      <li>
        <Link to="/Aboutcompany" className="hover:bg-gray-100 px-3 py-2 rounded-[2px] transition-colors">
          O Firmie
        </Link>
      </li>
      <li>
        <Link to="/FAQ" className="hover:bg-gray-100 px-3 py-2 rounded-[2px] transition-colors">
          FAQ
        </Link>
      </li>
      <li>
        <Link to="/contact" className="hover:bg-gray-100 px-3 py-2 rounded-[2px] transition-colors">
          Kontakt
        </Link>
      </li>
    </ul>
  </nav>
);

export default DesktopNav;